import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useParams } from "react-router-dom";

const LegalPage: React.FC = () => {
  const { page } = useParams<{ page: string }>();
  const [content, setContent] = useState("");

  useEffect(() => {
    const loadMarkdown = async () => {
      try {
        const file = await import(`../assets/legal/${page}.md`);
        const response = await fetch(file.default);
        const text = await response.text();
        setContent(text);
      } catch (err) {
        setContent("# Not Found\nThe page you’re looking for doesn’t exist.");
      }
    };
    loadMarkdown();
  }, [page]);

  return (
    <div className="min-h-screen bg-slate-900 text-gray-200 px-6 py-12">
      <div className="max-w-3xl mx-auto prose prose-invert">
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    </div>
  );
};

export default LegalPage;
